import { GtagKeys } from 'constants/analytics';

export const setGtagClientId = () => {
    if (window.gtag) {
        window.gtag('get', 'G-CD3646L2Q4', 'client_id', (clientId: string) => {
            localStorage.setItem(GtagKeys.gtagClientId, clientId);
        });
    }
};
